import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70c35914"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-5" }
const _hoisted_2 = { class: "base-title-button" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "add_circle", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "add_circle", -1))
const _hoisted_5 = { class: "table table-hover align-middle" }
const _hoisted_6 = { class: "border-dark border-bottom pb-2" }
const _hoisted_7 = { class: "border-dark border-bottom" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  colspan: 2,
  class: "fw-bold small text-uppercase text-muted"
}
const _hoisted_11 = { class: "name" }
const _hoisted_12 = { class: "name" }
const _hoisted_13 = { class: "buttons" }
const _hoisted_14 = { class: "d-flex justify-content-end align-items-center" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "delete", -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = ["placeholder"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-icon btn-primary border-0",
  id: "btnSearchSubmitLabosInclude",
  type: "submit"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "mas px-1" }, "search")
], -1))
const _hoisted_20 = {
  key: 0,
  class: "search-results list-group list-group-flush position-absolute w-100 overflow-auto shadow border border-1 border-top-0 border-light rounded-bottom"
}
const _hoisted_21 = {
  key: 0,
  class: "list-group-item"
}
const _hoisted_22 = {
  key: 1,
  class: "list-group-item fst-italic"
}
const _hoisted_23 = {
  key: 2,
  class: "list-group-item fst-italic"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "add", -1))
const _hoisted_25 = ["placeholder"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-icon btn-primary border-0",
  id: "btnSearchSubmitTrademarksInclude",
  type: "submit"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "mas px-1" }, "search")
], -1))
const _hoisted_27 = {
  key: 0,
  class: "search-results list-group list-group-flush position-absolute w-100 overflow-auto shadow border border-1 border-top-0 border-light rounded-bottom"
}
const _hoisted_28 = {
  key: 0,
  class: "list-group-item"
}
const _hoisted_29 = {
  key: 1,
  class: "list-group-item fst-italic"
}
const _hoisted_30 = {
  key: 2,
  class: "list-group-item fst-italic"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "add", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_modal_button = _resolveComponent("base-modal-button")!
  const _component_BaseTitle = _resolveComponent("BaseTitle")!
  const _component_alert_error = _resolveComponent("alert-error")!
  const _component_base_placeholder_table = _resolveComponent("base-placeholder-table")!
  const _component_base_move_buttons = _resolveComponent("base-move-buttons")!
  const _component_base_container = _resolveComponent("base-container")!
  const _component_CatalogBuildStatus = _resolveComponent("CatalogBuildStatus")!
  const _component_base_spinner = _resolveComponent("base-spinner")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_base_container, { "has-build-status-on-page": "" }, {
      default: _withCtx(() => [
        _createElementVNode("header", _hoisted_1, [
          _createVNode(_component_BaseTitle, {
            title: _ctx.$t('productOrderLaboTrademark'),
            "help-text": _ctx.$t('descriptionProductOrderLaboTrademark'),
            "show-refresh-button": "",
            "back-route": this.returnRouteObject,
            onRefresh: this.reloadContent
          }, {
            buttons: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_base_modal_button, {
                  class: "btn btn-hover icon-link",
                  "modal-id": this.addLaboModalId
                }, {
                  default: _withCtx(() => [
                    _hoisted_3,
                    _createTextVNode(_toDisplayString(_ctx.$t('addLabo')), 1)
                  ]),
                  _: 1
                }, 8, ["modal-id"]),
                _createVNode(_component_base_modal_button, {
                  class: "btn btn-hover icon-link",
                  "modal-id": this.addTrademarkModalId
                }, {
                  default: _withCtx(() => [
                    _hoisted_4,
                    _createTextVNode(_toDisplayString(_ctx.$t('addTrademark')), 1)
                  ]),
                  _: 1
                }, 8, ["modal-id"])
              ])
            ]),
            _: 1
          }, 8, ["title", "help-text", "back-route", "onRefresh"]),
          _createVNode(_component_alert_error, {
            exceptions: _ctx.exceptions,
            class: "mt-3"
          }, null, 8, ["exceptions"])
        ]),
        _createElementVNode("table", _hoisted_5, [
          _createElementVNode("thead", _hoisted_6, [
            _createElementVNode("tr", _hoisted_7, [
              _createElementVNode("th", null, _toDisplayString(_ctx.$t('name')), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t('type')), 1),
              _hoisted_8
            ])
          ]),
          _createElementVNode("tbody", null, [
            (!this.isReady)
              ? (_openBlock(), _createBlock(_component_base_placeholder_table, {
                  key: 0,
                  "n-cols": 2
                }))
              : (!this.hasBrandOrders)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                    _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.$t('noContentFound')), 1)
                  ]))
                : (this.isReady)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(this.brandOrders, (brandOrder) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: brandOrder.brand.code
                      }, [
                        _createElementVNode("td", _hoisted_11, _toDisplayString(brandOrder.brand.description), 1),
                        _createElementVNode("td", _hoisted_12, _toDisplayString(brandOrder.brand_type.description), 1),
                        _createElementVNode("td", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _createVNode(_component_base_move_buttons, {
                              onTop: ($event: any) => (this.moveBrand(brandOrder.brand.code, _ctx.MoveActionEnum.TOP)),
                              onUp: ($event: any) => (this.moveBrand(brandOrder.brand.code, _ctx.MoveActionEnum.UP)),
                              onDown: ($event: any) => (this.moveBrand(brandOrder.brand.code, _ctx.MoveActionEnum.DOWN)),
                              onBottom: ($event: any) => (this.moveBrand(brandOrder.brand.code, _ctx.MoveActionEnum.BOTTOM))
                            }, null, 8, ["onTop", "onUp", "onDown", "onBottom"]),
                            _createElementVNode("button", {
                              onClick: ($event: any) => (this.deleteBrand(brandOrder.brand.code)),
                              class: "btn btn-icon btn-danger ms-2"
                            }, _hoisted_17, 8, _hoisted_15)
                          ])
                        ])
                      ]))
                    }), 128))
                  : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_CatalogBuildStatus),
    _createVNode(_component_base_modal, {
      "modal-id": this.addLaboModalId,
      title: _ctx.$t('addLabo'),
      "no-footer": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["search-wrapper position-relative", {open: this.searchLaboQuery.length >= 2 }])
        }, [
          _createElementVNode("form", {
            class: "input-group",
            onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (this.submitLaboSearch && this.submitLaboSearch(...args)), ["prevent"]))
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((this.searchLaboQuery) = $event)),
              class: "form-control",
              id: "inputSearchLabo",
              placeholder: `${_ctx.$t('searchLabo')}...`,
              name: "searchLabo",
              autocomplete: "off",
              onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (this.submitLaboSearch && this.submitLaboSearch(...args)))
            }, null, 40, _hoisted_18), [
              [_vModelText, this.searchLaboQuery]
            ]),
            (this.hasLaboSearchQuery)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn-close",
                  id: "btnSearchResetLabos",
                  type: "reset",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (this.clearLaboSearch && this.clearLaboSearch(...args)))
                }))
              : _createCommentVNode("", true),
            _hoisted_19
          ], 32),
          (this.searchLaboQuery.length >= 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                (!this.isReadySearch)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createVNode(_component_base_spinner)
                    ]))
                  : (this.exceptions.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(this.exceptions[0].message), 1))
                    : (!this.hasSearchedLabos)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_ctx.$t('noBrandsFound')), 1))
                      : (this.isReadySearch)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(this.searchedLabos, (searchedBrand) => {
                            return (_openBlock(), _createBlock(_component_base_modal_button, {
                              key: searchedBrand.code,
                              mode: "close",
                              class: "list-group-item list-group-item-action d-flex justify-content-between align-items-center",
                              onClick: _withModifiers(($event: any) => {this.addBrand(searchedBrand.code, _ctx.BrandTypeEnum.LABO);}, ["prevent"])
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", null, _toDisplayString(searchedBrand.description), 1),
                                _hoisted_24
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          }), 128))
                        : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ]),
      _: 1
    }, 8, ["modal-id", "title"]),
    _createVNode(_component_base_modal, {
      "modal-id": this.addTrademarkModalId,
      title: _ctx.$t('addTrademark'),
      "no-footer": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["search-wrapper position-relative", {open: this.searchTrademarkQuery.length >= 2 }])
        }, [
          _createElementVNode("form", {
            class: "input-group",
            onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (this.submitTrademarkSearch && this.submitTrademarkSearch(...args)), ["prevent"]))
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((this.searchTrademarkQuery) = $event)),
              class: "form-control",
              id: "inputSearchTrademark",
              placeholder: `${_ctx.$t('searchTrademark')}...`,
              name: "searchTrademark",
              autocomplete: "off",
              onKeyup: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (this.submitTrademarkSearch && this.submitTrademarkSearch(...args)))
            }, null, 40, _hoisted_25), [
              [_vModelText, this.searchTrademarkQuery]
            ]),
            (this.hasTrademarkSearchQuery)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn-close",
                  id: "btnSearchResetTrademarks",
                  type: "reset",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (this.clearTrademarkSearch && this.clearTrademarkSearch(...args)))
                }))
              : _createCommentVNode("", true),
            _hoisted_26
          ], 32),
          (this.searchTrademarkQuery.length >= 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                (!this.isReadySearch)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      _createVNode(_component_base_spinner)
                    ]))
                  : (this.exceptions.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(this.exceptions[0].message), 1))
                    : (!this.hasSearchedTrademarks)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(_ctx.$t('noTrademarksFound')), 1))
                      : (this.isReadySearch)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(this.searchedTrademarks, (searchedTrademark) => {
                            return (_openBlock(), _createBlock(_component_base_modal_button, {
                              key: searchedTrademark.code,
                              mode: "close",
                              class: "list-group-item list-group-item-action d-flex justify-content-between align-items-center",
                              onClick: _withModifiers(($event: any) => {this.addBrand(searchedTrademark.code, _ctx.BrandTypeEnum.TRADEMARK);}, ["prevent"])
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", null, _toDisplayString(searchedTrademark.description), 1),
                                _hoisted_31
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          }), 128))
                        : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ]),
      _: 1
    }, 8, ["modal-id", "title"])
  ], 64))
}